/*
Monotype Foundry Platform API
Version 1.0.0

Definition: QuarterlyRoyaltiesStatementsRequest

Properties:
  items: array (required)
*/

var QuarterlyRoyaltiesStatementsRequest = (function () {
  function validateQuarterlyRoyaltiesStatementsRequest (arg) {
    // Validate items
    if (!arg.items) {
      throw new Error('QuarterlyRoyaltiesStatementsRequest.items: Missing property')
    }
    if (arg.items && !(Array.isArray(arg.items))) {
      throw new Error('QuarterlyRoyaltiesStatementsRequest.items: Wrong type: Got \'' + (typeof arg.items) + '\', but expected: \'array\'')
    }
  }
  function buildQuarterlyRoyaltiesStatementsRequest (arg) {
    var QuarterlyRoyaltiesStatementsRequest = arg
    // Complete items
    // Expected Type: array
    QuarterlyRoyaltiesStatementsRequest.items = QuarterlyRoyaltiesStatementsRequest.items || []
    return QuarterlyRoyaltiesStatementsRequest
  }
  return {
    validate: validateQuarterlyRoyaltiesStatementsRequest,
    build: buildQuarterlyRoyaltiesStatementsRequest
  }
})()

module.exports = QuarterlyRoyaltiesStatementsRequest
